import ajax from "./ajax";

export const requestGraphData = (query) => {
  return ajax("/counts/dashboard", { query });
};

export const requestPrintingStats = (query) => {
  return ajax("/printing/printing_stats", { query });
};

export const setCustomizeButtonHit = (data) => {
  return ajax("/dashboard/tasks", { method: "PUT", data });
};

export const updateDashboardTasks = (data) => {
  return ajax("/dashboard/tasks", { method: "PUT", data });
};
